export enum MicrophoneKeys {
    MicrophoneInitializationDuration = "MicrophoneInitializationDuration",
    MicrophonePermissionsPreviouslyGranted = "MicrophonePermissionsPreviouslyGranted",
    MicrophoneSuccessfullyInitialized = "MicrophoneSuccessfullyInitialized",
    MicrophoneInitFailureReason = "MicrophoneInitFailureReason"
};